import { render, staticRenderFns } from "./TicketDescription.vue?vue&type=template&id=21f9e3b4&scoped=true&"
import script from "./TicketDescription.vue?vue&type=script&lang=js&"
export * from "./TicketDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f9e3b4",
  null
  
)

export default component.exports